import React from 'react'

// Single shimmer-keyframes block, shared by all Skeleton instances.
// Inline <style> is mounted once via the wrapper to keep the
// primitive standalone (no global CSS edit needed in Phase A).

let injected = false
const injectKeyframes = () => {
  if (injected || typeof document === 'undefined') return
  const style = document.createElement('style')
  style.setAttribute('data-itemzo-skeleton', '')
  style.textContent = `
    @keyframes itemzo-skeleton-shimmer {
      0%   { background-position: -480px 0; }
      100% { background-position:  480px 0; }
    }
    .itemzo-skeleton {
      background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
      background-size: 480px 100%;
      animation: itemzo-skeleton-shimmer 1.4s infinite linear;
    }
  `
  document.head.appendChild(style)
  injected = true
}

const RADIUS = {
  sm:   'rounded-md',
  md:   'rounded-lg',
  card: 'rounded-card',
  pill: 'rounded-pill',
  full: 'rounded-full',
  none: 'rounded-none',
}

// Generic skeleton block.
// Usage:
//   <Skeleton className='w-full h-40' />
//   <Skeleton radius='full' className='w-12 h-12' />
//   <Skeleton.Text lines={3} />
const Skeleton = ({ radius = 'md', className = '', style, ...rest }) => {
  if (typeof window !== 'undefined') injectKeyframes()
  return (
    <div
      className={`itemzo-skeleton ${RADIUS[radius] || RADIUS.md} ${className}`}
      style={style}
      aria-hidden='true'
      {...rest}
    />
  )
}

Skeleton.Text = ({ lines = 3, className = '' }) => (
  <div className={`flex flex-col gap-2 ${className}`}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        radius='md'
        className='h-3'
        style={{ width: `${85 - i * 12}%` }}
      />
    ))}
  </div>
)

Skeleton.Card = ({ className = '' }) => (
  <div className={`flex flex-col gap-3 ${className}`}>
    <Skeleton radius='card' className='w-full aspect-square' />
    <Skeleton radius='md' className='h-4 w-3/4' />
    <Skeleton radius='md' className='h-4 w-1/2' />
    <Skeleton radius='md' className='h-9 w-full' />
  </div>
)

export default Skeleton
